import * as actionTypes from '../actions/allActionList';
import { updateStateWithoutNesting } from '../../utils/store/updateStateWithoutNesting';

const initialState = {
  fetching: false,
  classrooms: null,
  allClassroomsLength: 0,
  fetchingError: null,
  isFull: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_CLASSROOMS_STARTED:
      return updateStateWithoutNesting(state, { fetching: true });
    case actionTypes.FETCHED_ALL_CLASSROOMS:
      return {
        ...state,
        fetching: false,
        allClassroomsLength: action.length,
        classrooms: [...action.classrooms],
      };
    case actionTypes.FAILED_TO_FETCH_ALL_CLASSROOMS:
      return updateStateWithoutNesting(state, {
        fetching: false,
        fetchingError: 'Unexpected server error!',
      });
    case actionTypes.CLASSROOM_IS_FULL:
      return updateStateWithoutNesting(state, { isFull: true });
    case actionTypes.CLASSROOM_IS_OPEN:
      return updateStateWithoutNesting(state, { isFull: false });
    default:
      return state;
  }
};

export default reducer;
